import axios from 'axios';

export const updateTenant = async (tenant) => {
  const url = `${process.env.REACT_APP_API_URL}/tenants/${tenant.id}`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.put(url,{...tenant},{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


